import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet, } from '@angular/router';
import { Subscription } from 'rxjs';
import { MetaService } from './services/meta.service';
import { NavigationService } from './services/navigation/navigation.service';
import { getConsentConfig } from '@environments/cookie_consent';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [ RouterOutlet ],
	providers: [
		NavigationService,
	],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
	title = "";

	constructor(
		private nav: NavigationService,
		private meta: MetaService,
	) { }

	ngOnInit(): void {
		this.meta.setBasicMeta();
		this.showConsent();
	}

	ngOnDestroy() {
	}

	private showConsent() {
		if (typeof window == "undefined") return;
		let cc = window as any;
		if (!cc.cookieconsent) return;
		const termsLinks = this.nav.getTerms();
		cc.cookieconsent.initialise(getConsentConfig());
	}

}
